import { render, staticRenderFns } from "./exames.vue?vue&type=template&id=7f0f8c2b&scoped=true"
import script from "./exames.vue?vue&type=script&lang=js"
export * from "./exames.vue?vue&type=script&lang=js"
import style0 from "./exames.vue?vue&type=style&index=0&id=7f0f8c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0f8c2b",
  null
  
)

export default component.exports